export default __webpack_public_path__ + "static/media/Logo11.bbb0c0f6.png";